import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./claimBonusPop.module.scss";
import congratsImg from "../../../assets/images/congratsPopGot.png";
import { useSelector } from "react-redux";
import styled from "styled-components";
import current from "../../../assets/images/current.png";
import diamond from "../../../assets/images/diamond.png";

const ClaimBonusPop = ({ showClaimBonus, setShowClaimBonus, onFinish }) => {
  const welcomeBonus = useSelector(({ Auth }) => Auth.welcomeBonus);
  const welcomeBonusLoading = useSelector(
    ({ Auth }) => Auth.welcomeBonusLoading,
  );

  // Open modal only when welcomeBonus is updated
  useEffect(() => {
    if (welcomeBonus && !welcomeBonusLoading) {
      setShowClaimBonus(true);
    }
  }, [welcomeBonus, welcomeBonusLoading, setShowClaimBonus]);
  const handledHide = () => {
    setShowClaimBonus(false);
    onFinish();
  };

  if (welcomeBonusLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Modal
      show={showClaimBonus}
      backdrop="true"
      className={`${styles.buyPop} bottomPop`}
      centered
      keyboard={false}
    >
      <div className="modalWrpper">
        <Modal.Body>
          <Button
            onClick={handledHide}
            variant="transparent"
            className="border-0 p-0 position-absolute"
            style={{ top: 15, right: 15, zIndex: 999 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                fill="#506380"
              />
            </svg>
          </Button>
          <div className="top text-center">
            <div className="position-relative">
              <img src={congratsImg} alt="" className="img-fluid w-100" />
            </div>
            {/* <h5
              className="m-0 text-white d-block  mt-4 pb-1 fw-bold"
              // style={{ borderBottom: "1px solid #02ADEA" }}
            >
              YOU WON
            </h5> */}
            <div
              // style={{ background: "#13131B" }}
              className="py-1 px-3 d-inline-block rounded"
            >
              <h5
                className="fw-bold my-2"
                style={{
                  color: "#3d71d3",
                  fontSize: "26px",
                  textAlign: "center",
                  textShadow: "1px 2px 1px rgb(35 62 114)",
                }}
              >
                {welcomeBonus?.amount
                  ?.toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                {welcomeBonus?.coinName}
              </h5>
            </div>
          </div>
          <div className="text-center">
            <div className="py-2">
              <img
                src={welcomeBonus?.coinGif}
                // src="https://sound.bitanicagames.com/pepe.gif"
                className="img-fluid object-contain"
                style={{ height: 200 }}
                alt=""
              />
            </div>
            <div className="py-2">
              <CardList className="list-unstyled ps-0 mb-0 d-flex flex-column">
                {welcomeBonus?.energyBalance > 0 && (
                  <li className="py-1">
                    <div className="cardWrp d-flex align-items-center text-white cursor-pointer justify-content-between gap-10 p-2">
                      <div className="left d-flex align-items-center gap-10">
                        <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                          <img
                            src={current}
                            alt="card"
                            className="img-fluid"
                            style={{ height: 25 }}
                          />
                        </span>
                        Energy Bonus
                      </div>
                      <p className="m-0">{welcomeBonus?.energyBalance}</p>
                    </div>
                  </li>
                )}

                {welcomeBonus?.btncCoin > 0 && (
                  <li className="py-1">
                    <div className="cardWrp d-flex align-items-center text-white cursor-pointer justify-content-between gap-10 p-2">
                      <div className="left d-flex align-items-center gap-10">
                        <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                          <img
                            src={diamond}
                            alt="card"
                            className="img-fluid"
                            style={{ height: 25 }}
                          />
                        </span>
                        BTNC Bonus
                      </div>
                      <p className="m-0">{welcomeBonus?.btncCoin}</p>
                    </div>
                  </li>
                )}
              </CardList>
            </div>
            <div className=" text-center pb-2">
              <Button
                onClick={handledHide}
                style={{ maxWidth: 171 }}
                className="d-inline-flex  align-items-center justify-content-center fw-bold commonBtn border-0"
              >
                Claim
              </Button>
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

const CardList = styled.div`
  .cardWrp {
    background: rgb(21, 21, 22);
    border-radius: 10px;
    min-height: 60px;
    font-size: 14px;
    font-family: "Space Grotesk", sans-serif;
    font-weight: 300;
    border: 1px solid transparent;
    .icn {
      height: 43px;
      width: 46px;
      background: rgb(45, 45, 45);
      border-radius: 10px;
    }
  }
`;

export default ClaimBonusPop;
